import { List } from "antd";
import React, { FC } from "react";
import { ActionBanner } from "../ActionBanner";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { JHTML } from "../JHTML";

export type HowToDetailsProps = {
    title: string,
    description: string,
    data: Detail[],
    actionTitle?: string;
    actionLabel?: string;
    actionCallback?: () => void
};

export type Detail = {
    title: string;
    description: string;
}

/**
 * How To Details component
 *
 * @param {HowToDetailsProps} props
 * @return {*} 
 */
export const HowToDetails: FC<HowToDetailsProps> = (
    {
        title,
        description,
        data,
        actionTitle,
        actionLabel,
        actionCallback
    }
) => {
    return (
        <div className="how-to-details-container">
             {title && <JHTML.Title html={title}/>}
            {description && <JHTML.Text html={description}/>}
            {!!data?.length &&
                <div className="how-to-details-data">
                    <List
                        dataSource={data}
                        renderItem={(item, index) => (
                            <List.Item key={index}>
                                <List.Item.Meta
                                    avatar={<QuestionCircleOutlined aria-hidden={true}/>}
                                    title={<div>{item.title}</div>}
                                    description={<div>{item.description}</div>}
                                />
                            </List.Item>
                        )}
                    />
                </div>
            }
            {actionTitle && actionLabel && actionCallback &&
                <ActionBanner title={actionTitle} actionLabel={title} actionCallback={actionCallback} />
            }
        </div>
    )
}
